/**
 * PilotLogo component.
 */
import Channel from '@shared/classes/channel';
import Logo from '@components/atoms/images/centerChannelLogo';

/**
 * PilotLogo props.
 */
interface Props {
  channel?: Channel;
  display: boolean;
}

/**
 * Displays the channel logo if the display prop is true.
 */
export default function PilotLogo({ channel, display }: Props) {
  return display ? <Logo key={channel?.id} src={channel?.logo} /> : null;
}
